<template>
  <div class="mycar text-c">
    <div class="car-box" v-for="item in list" :key="'list_' + item.id">
      <img class="ellipsispic" :src="img.ellipsis" @click="showBottom(item.id,item.is_audit)">
      <div class="area_box" @click="goInfo(item.id,item.is_audit)">
        <img class="area_pic" v-if="item.car" :src="item.car.pic">
        <img class="area_pic" v-else :src="item.car_pic_url?item.car_pic_url:item.brand.logo">
        <div class="area_titie">
          <div>{{item.car?item.car.title:item.car_name}}</div>
          <div class="f-12 c-gray" v-if="item.is_audit==0">认证审核中</div>
          <div class="f-12 c-gray" v-if="item.is_audit==2">审核未通过</div>
        </div>
      </div>
      <img class="carpoint" :src="item.is_default==1?img.point_active:img.point" @click="chooseDefault(item.id)">
    </div>
    <van-button icon="add-o" @click="goCarList">添加认证车辆</van-button>
    <div class="othercarbox" @click="goCars">
      <img class="othercar" :src="img.othercar">
    我曾拥有雷克萨斯其他车型，如何申请认证?</div>
    <van-popup
    v-model="approve"
    position="bottom"
    :style="{ height: '13%' }"
    >
    <van-cell-group>
      <van-cell :title="goTitle" @click="approveCar" />
      <van-cell title="删除车辆" @click="delCar" />
    </van-cell-group>
  </van-popup>
</div>
      <!-- <div v-for="item in list" :key="'list_' + item.id">
        <div class="car">
         <van-image
         width="190"
         height="100"
         fit="contain"
         :src="item.car.pic"
         />
         <van-row type="flex" justify="space-between">
          <van-col class="f-15 f-w carstype" span="8">{{item.brand.title}}{{item.car.title}}</van-col>
          <van-col class="platenum" span="8">
            <van-tag v-if="item.is_audit==0" round :data-code='item.id' :data-audit='item.is_audit' @click="showBottom">认证未成功</van-tag>
            <span v-else :data-code='item.id' :data-audit='item.is_audit' @click="showBottom">
              <van-tag class="province" type="primary">{{item.p_plate}}</van-tag>
              <van-tag plain type="primary">{{item.p_num}}</van-tag>
            </span>
          </van-col>
        </van-row>
        
      </div> -->
    <!-- <div class="nocar">
      <van-popup
      v-model="show"
      position="right"
      @close="close"
      :style="{ width: '100%', height: '100%' }"
      >
      <van-nav-bar
      :title="popTitle"
      left-arrow
      @click-left="onClickLeft"
      /> -->
    <!-- <van-index-bar v-show="brands" highlight-color="#F6AB00">
      <div v-for="(item, index) in brandlist" :key="'list_' +index" >
        <van-index-anchor :index="index" />
        <div v-for="itemd in item" :key="'listd_' + itemd.id">
          <van-cell @click="changeCar" :icon="itemd.logo" :data-img="itemd.logo" :data-name="itemd.title" :data-code='itemd.id' :title="itemd.title" title-class="text-l f-w mt-5" />
        </div>
      </div>
    </van-index-bar> -->
    <!-- <div class="cars" v-show="cars">
      <van-cell class="bg" :icon="brand_img" :title="brand_name" title-class="text-l f-w" />
      <van-cell v-for="item in carslist" :key="'listc_' + item.id" @click="changeModel" :data-name="item.title" :data-code='item.id' :title="item.title" :icon="item.pic" title-class="text-l f-w mt-5" />
    </div>
    <div v-show="models">
      <van-cell class="bg" :title="model_name" title-class="text-l f-w" />
      <van-cell @click="changeOk" v-for="item in modelist" :key="'listm_' + item.id" :data-code='item.id' :data-name="item.title" :title="item.year+'款 '+ item.title" :label="item.year" title-class="text-l f-w" />
    </div>
  </van-popup> -->
  
</template>
<script>
  import common from '../../../api/common';
  import list from '../../../api/member/mycars';
  import { mapState } from 'vuex';
  import {Icon,Button,Row,Col,Image,Tag,Overlay,Popup,NavBar,IndexBar,IndexAnchor,Cell,CellGroup,Dialog} from "vant";
  export default {
    data () {
      return {
        show:false,
        approve:false,
        activeTab: 0,
        popTitle:'选择车系',
        cars:true,
        models:false,
        list: [],
        brandlist:[],
        carslist:[],
        modelist:[],
        brand_id:1,
        car_id:'',
        car_model_id:'',
        brand_img:'',
        brand_name:'',
        model_name:'',
        goTitle:'',
        indexList: ['A','B', 'C','D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M','N','O', 'P','Q','R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
        img:{
          point: require('../../../assets/img/lexus/point.png'),
          othercar: require('../../../assets/img/lexus/othercar.png'),
          point_active: require('../../../assets/img/lexus/point_active.png'),
          ellipsis: require('../../../assets/img/lexus/ellipsis.png'),
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: true})
      this.$appService.isTabbar({state: true})
      this.weburl=process.env.VUE_APP_URL
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          this.$appService.needLogin()
        }
      })
      if(this.$route.params.show){
        this.$appService.isShowReturn({state: false})
        this.$appService.isTabbar({state: true})
        this.show=this.$route.params.show
        this.getCars()
      }
      this.getMycars()
      var params={
        event_code: '车主认证_我的车辆',
        event_id: '',
        title: '',
        value: '',
        path: '/Lexus/My/MyCars.vue',
        user_id: this.user ? this.user.id : 0,
        source: this.source
      }
      common.BurialPoint(params).then(res => {
        if(res.data.state==1){
        }
      })
      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
    },
    methods: {
      getMycars(){
        var params={
          brand_id: 1
        }
        list.getMycars(params).then(res => {
          if(res.data.state == 1) {
            let list=res.data.data
            for(var i=0;i<list.length;i++){
              var number_plate= list[i].number_plate
              list[i].p_plate = number_plate.substring(0, 1)
              list[i].p_num = number_plate.substring(1, 7)
            }
            this.list=list
          }
        })
      },
      getCars(){
        list.getCars(this.brand_id).then(res => {
          if(res.data.state == 1) {
            this.carslist=res.data.data
          }
        })
      },
      goCarList(){
        var params={
          url:this.weburl+'/lexus/my/approve?source='+this.source,
          isReturn: true 
        }
        this.$appService.openWebView(params)
        // this.show=true
        // this.getCars()
        // this.$appService.isShowReturn({state: false})
        // this.$appService.isTabbar({state: true})
      },
      goCars(){
        Dialog.alert({
          title: '',
          message: '是否有行驶证',
          confirmButtonText:'有行驶证',
          cancelButtonText:'无行驶证',
          showCancelButton:true,
        }).then(() => {
          var params={
            url:this.weburl+'/lexus/my/car_list?type=1&is_have_card=1&ever=1&source='+this.source ,
            isReturn: true 
          }
          this.$appService.openWebView(params)
        })
        .catch(() => {
          var params={
            url:this.weburl+'/lexus/my/car_list?type=1&is_have_card=0&ever=1&source='+this.source ,
            isReturn: true 
          }
          this.$appService.openWebView(params)
        });
      },
      showBottom(carid,audit){
        this.carid=carid
        this.audit=audit
        if(audit==1){
          this.goTitle='查看详情'
        }else{
          this.goTitle='继续认证'
        }
        this.approve=true
      },
      approveCar(){
        let carid=this.carid
        this.approve=false
        var params={
          url:this.weburl+'/lexus/my/car_info?carid='+this.carid+'&audit='+this.audit+'&source='+this.source,
          isReturn: true 
        }
        this.$appService.openWebView(params)

      },
      chooseDefault(id){
        list.chooseDefault(id).then(res => {
          if(res.data.state == 1) {
            var list = this.list
            for (var i = 0; i < list.length; i++) {
              if (list[i].id == id) {
                list[i].is_default = 1
              } else {
                list[i].is_default = 0
              }
            }
            this.list=list
          }
        })
      },
      delCar(){
        var carid=parseInt(this.carid)
        this.$dialog.confirm({
          message: '确定要删除吗？'
        }).then(() => {
          list.delCar(carid).then(res => {
            if(res.data.state == 1) {
              this.approve=false
              this.$toast.success('删除成功');
              this.getMycars()
            }
          })
        }).catch(() => {
        });
      },
      goInfo(id,audit){
        if(audit==0){
          var params={
            url:this.weburl+'/lexus/my/checkcar_audit?source='+this.source,
            isReturn: true 
          }
          this.$appService.openWebView(params)
        }else{
          var params={
            url:this.weburl+'/lexus/my/car_info?carid='+id+'&audit='+audit+'&source='+this.source,
            isReturn: true 
          }
          this.$appService.openWebView(params)
        }
      }
    },
    components: {
      [Icon .name]: Icon ,
      [Button.name]: Button,
      [Row .name]: Row,
      [Col.name]: Col,
      [Image.name]:Image,
      [Tag.name]:Tag,
      [Popup.name]:Popup,
      [IndexBar.name]:IndexBar,
      [IndexAnchor.name]:IndexAnchor,
      [NavBar.name]:NavBar,
      [Cell.name]:Cell,
      [CellGroup.name]:CellGroup,
      [Dialog.name]:Dialog
    }
  };
</script>
<style lang="scss">
.mycar{
  padding: 0 15px;
  .car-box{
    padding: 20px 0 10px 0;
    border-bottom: 0.5px solid rgba(0,0,0,.1);

    .ellipsispic{
      float: right;
      width: 17px;
      height: 3px;
      display: block;
    }

    .carpoint{
      width: 8px;
      height: 8px;
      display: block;
      margin-top: 15px;
    }
    .area_box{
      display: flex;
      align-items: center;
      margin-right: 15px;
      .area_pic{
        width: 150px;
        height: 80px;
        margin-left: 25px;
      }
      .area_titie{
        flex: 1;
        font-size:16px;
        text-align: center;
      }
      .arrow{
        width: 10px;
        height: 12px;
        float: right;
      }
    } 
  } 
  .van-button{
    margin-top: 30px;
    width: 200px;
    height: 45px;
    color: #fff;
    background-color: #605C6B;
    margin-bottom: 30px;
  }
  .othercarbox{
    color:#1F2A74;
    text-align: center;
    padding-bottom: 40px;
    font-size: 14px;
    .othercar{
      width: 14px;
      height: 14px;
      vertical-align: middle;
    }
  }
}

</style>